"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen["return"] !== "function") { this["return"] = undefined; } }

if (typeof Symbol === "function" && Symbol.asyncIterator) { _AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; }

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype["throw"] = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype["return"] = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

var render = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payloadF) {
    var generator, payloadProps, init, _yield$_awaitAsyncGen, value, done;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return null;

          case 2:
            payloadProps = _context.sent;
            // Dry run to see if we are dealing with a user provided generator
            init = payloadF(payloadProps);

            if (init && init._invoke) {
              generator = init;
            }

          case 5:
            if (!true) {
              _context.next = 23;
              break;
            }

            if (generator) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return Promise.resolve(payloadF(payloadProps));

          case 9:
            payloadProps = _context.sent;
            _context.next = 21;
            break;

          case 12:
            _context.next = 14;
            return _awaitAsyncGenerator(generator.next(payloadProps));

          case 14:
            _yield$_awaitAsyncGen = _context.sent;
            value = _yield$_awaitAsyncGen.value;
            done = _yield$_awaitAsyncGen.done;
            _context.next = 19;
            return Promise.resolve(value);

          case 19:
            payloadProps = _context.sent;

            // Rewind after user-provided generator `return` statement
            if (done) {
              generator = payloadF(payloadProps);
            }

          case 21:
            _context.next = 5;
            break;

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function render(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = render;
exports["default"] = _default;